let filters = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');

filtersOpen.addEventListener('click', openFilters);

for (let i = 0; i < filtersClose.length; i++) {
    filtersClose[i].addEventListener('click', closeFilters);
}

function openFilters() {
    filters.classList.add('open');
    document.body.classList.add('filters-open');
}

function closeFilters() {
    filters.classList.remove('open');
    document.body.classList.remove('filters-open');
}

let tagCheckbox = document.querySelectorAll('#filterform .checkbox input');
for (let i = 0; i < tagCheckbox.length; i++) {
    tagCheckbox[i].addEventListener('change', filterChanged);
}

var parts = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
if (parts.indexOf('http://') != 0 || parts.indexOf('https://') != 0) {
    parts.forEach(function (item, index) {
        var param = item.split('=');
        var key = param[0];
        var value = decodeURIComponent(param[1]).split(',');
        for (var j = 0; j < value.length; ++j) {
            var filterOptions = document.getElementsByName(key);
            for (var i = 0; i < filterOptions.length; i++) {
                value[j].replace(/\s/g, '');
                if (filterOptions[i].value === value[j]) {
                    filterOptions[i].setAttribute('checked', true)
                }
            }
        }
    });
}

let jsCategories = document.querySelectorAll('.js-categories');

jsCategories.forEach(function (el) {
    el.addEventListener('click', function () {
        jsCategories.forEach(function (item) {
            item.classList.remove('js-open');
        });

        this.classList.add('js-open');
    });
});

let jsRadioTypes = document.querySelectorAll('.disciplines input');

jsRadioTypes.forEach(function (el) {
    el.addEventListener('click', function () {
        var thisChecked = false;
        var thisValue = this.value;

        if (this.checked === true) {
            thisChecked = true;
        }

        /* siblings fields */
        jsRadioTypes.forEach(function (sibling) {
            sibling.checked = false;
        });

        /* swapped states because checked is faster than click */
        if (thisChecked) {
            el.checked = true;
        } else {
            el.checked = false;
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    let jsRadioTypes = document.querySelectorAll('.disciplines input');

    if (jsRadioTypes) {

        jsRadioTypes.forEach(function (item) {

            if (item.checked === true) {
                item.parentElement.parentElement.parentElement.parentElement.querySelector('.js-categories').classList.add('js-open');
            }

        });
    }
});

function filterChanged() {
    var arrayChecked = []
    var checkboxes = document.querySelectorAll('#filterform input[type=checkbox]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
        var key = checkboxes[i].name;
        var info = checkboxes[i].value;
        var temp = {};

        if (arrayChecked[key]) {
            arrayChecked[key].push(info);
        } else {
            arrayChecked[key] = [info];
        }
    }

    var url = document.querySelector('#filterform').getAttribute('data-url');
    for (var key in arrayChecked) {
        url += (url.indexOf('?') >= 0) ? '&' : '?';
        url += key + '=' + arrayChecked[key].join(',');
    }
    window.location.href = url;
}
